(function () {
  var galleries = {};
  var boundSections = {};

  function getGalleryRoot(target) {
    return target ? target.closest("[data-qsmg-root]") : null;
  }

  function getGalleryId(root) {
    return root ? String(root.getAttribute("data-qsmg-root") || "") : "";
  }

  function setActiveThumb(root, index) {
    if (!root) {
      return;
    }

    var thumbs = root.querySelectorAll("[data-qsmg-thumb]");
    thumbs.forEach(function (thumb, thumbIndex) {
      var isActive = thumbIndex === index;
      thumb.classList.toggle("is-active", isActive);
      thumb.setAttribute("aria-current", isActive ? "true" : "false");
    });

    if (thumbs[index] && typeof thumbs[index].scrollIntoView === "function") {
      thumbs[index].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }

  function findThumbIndexByImageId(root, imageId) {
    if (!root || !imageId) {
      return -1;
    }

    var thumbs = root.querySelectorAll("[data-qsmg-thumb]");
    for (var i = 0; i < thumbs.length; i++) {
      if (String(thumbs[i].getAttribute("data-qsmg-image-id")) === String(imageId)) {
        return i;
      }
    }

    return -1;
  }

  function getInitialThumbIndex(root) {
    if (!root) {
      return 0;
    }

    var initialImageId = root.getAttribute("data-qsmg-initial-image-id");
    var initialIndex = findThumbIndexByImageId(root, initialImageId);
    return initialIndex > -1 ? initialIndex : 0;
  }

  function bindVariantListener(root) {
    if (!root) {
      return;
    }

    var sid = getGalleryId(root);
    var section = root.closest(".product-section");
    if (!sid || !section || boundSections[sid]) {
      return;
    }

    boundSections[sid] = true;

    section.addEventListener("variantChange", function (event) {
      var variant = event && event.detail ? event.detail.variant : null;
      if (!variant) {
        return;
      }

      var imageId = null;
      if (variant.featured_image && variant.featured_image.id) {
        imageId = variant.featured_image.id;
      } else if (
        variant.featured_media &&
        variant.featured_media.preview_image &&
        variant.featured_media.preview_image.id
      ) {
        imageId = variant.featured_media.preview_image.id;
      }

      if (!imageId) {
        return;
      }

      var targetIndex = findThumbIndexByImageId(root, imageId);
      if (targetIndex < 0) {
        return;
      }

      setActiveThumb(root, targetIndex);

      var gallery = galleries[sid];
      if (gallery && gallery.swiper && gallery.viewer && gallery.viewer.classList.contains("is-open")) {
        gallery.swiper.slideTo(targetIndex);
      }
    });
  }

  function setupRoot(root) {
    if (!root) {
      return;
    }

    bindVariantListener(root);
    setActiveThumb(root, getInitialThumbIndex(root));
  }

  function initGallery(root) {
    var sid = getGalleryId(root);
    if (!sid || typeof Swiper === "undefined") {
      return null;
    }

    if (galleries[sid] && galleries[sid].viewer && document.body.contains(galleries[sid].viewer)) {
      return galleries[sid];
    }

    var viewer = root.querySelector("[data-qsmg-viewer]");
    var swiperEl = viewer ? viewer.querySelector(".qsmg__viewer-swiper") : null;
    if (!viewer || !swiperEl) {
      return null;
    }

    if (galleries[sid] && galleries[sid].swiper && typeof galleries[sid].swiper.destroy === "function") {
      galleries[sid].swiper.destroy(true, true);
    }

    galleries[sid] = {
      root: root,
      viewer: viewer,
      swiper: new Swiper(swiperEl, {
        initialSlide: 0,
        slidesPerView: 1,
        speed: 280,
        zoom: {
          maxRatio: 3,
          minRatio: 1,
        },
        navigation: {
          nextEl: viewer.querySelector(".swiper-button-next"),
          prevEl: viewer.querySelector(".swiper-button-prev"),
        },
        observer: true,
        observeParents: true,
        on: {
          init: function () {
            setActiveThumb(root, this.activeIndex || 0);
          },
          slideChange: function () {
            setActiveThumb(root, this.activeIndex || 0);
          },
        },
      }),
    };

    setActiveThumb(root, getInitialThumbIndex(root));

    return galleries[sid];
  }

  function openGallery(root, index) {
    var gallery = initGallery(root);
    if (!gallery) {
      return;
    }

    gallery.viewer.classList.add("is-open");
    gallery.viewer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    gallery.swiper.update();
    gallery.swiper.slideTo(index, 0);
    setActiveThumb(root, index);
  }

  function closeGallery(root) {
    var sid = getGalleryId(root);
    var gallery = sid ? galleries[sid] : null;
    if (!gallery) {
      return;
    }

    gallery.viewer.classList.remove("is-open");
    gallery.viewer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-qsmg-thumb]");
    if (thumb) {
      var root = getGalleryRoot(thumb);
      if (root) {
        openGallery(root, Number(thumb.getAttribute("data-qsmg-thumb")) || 0);
      }
      return;
    }

    var closeBtn = event.target.closest("[data-qsmg-close]");
    if (closeBtn) {
      var closeRoot = getGalleryRoot(closeBtn);
      if (closeRoot) {
        closeGallery(closeRoot);
      }
      return;
    }

    var quickModalClose = event.target.closest(".modal--quick-shop .js-modal-close");
    if (quickModalClose) {
      var openViewers = document.querySelectorAll(".qsmg__viewer.is-open");
      openViewers.forEach(function (viewer) {
        var root = viewer.closest("[data-qsmg-root]");
        if (root) {
          closeGallery(root);
        }
      });
      return;
    }

    var viewer = event.target.closest(".qsmg__viewer");
    if (viewer && event.target === viewer) {
      var viewerRoot = getGalleryRoot(viewer);
      if (viewerRoot) {
        closeGallery(viewerRoot);
      }
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") {
      return;
    }

    var openViewer = document.querySelector(".qsmg__viewer.is-open");
    if (!openViewer) {
      return;
    }

    var root = openViewer.closest("[data-qsmg-root]");
    if (root) {
      closeGallery(root);
    }
  });

  function setupAllRoots(scope) {
    var roots = (scope || document).querySelectorAll("[data-qsmg-root]");
    roots.forEach(setupRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setupAllRoots(document);
    });
  } else {
    setupAllRoots(document);
  }

  document.addEventListener("quickview:loaded", function () {
    setupAllRoots(document);
  });

  document.addEventListener("quickview:open", function () {
    setupAllRoots(document);
  });
})();
